import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 bg-sage-light relative overflow-hidden" data-id="element-153">
      {/* Decorative leaf shape */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-sage opacity-5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-154"></div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-155">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-156">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white text-sage-dark mb-8 shadow-sm" data-id="element-157">
            <AlertCircle className="w-8 h-8" data-id="element-158" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif text-dark mb-8" data-id="element-159">
            ¿Por qué no funciona nada?
          </h2>

          <div className="bg-white/60 backdrop-blur-sm p-8 md:p-10 rounded-3xl shadow-sm border border-white/50" data-id="element-160">
            <p className="text-lg md:text-xl text-dark/80 leading-relaxed" data-id="element-161">
              Los químicos disruptores hormonales están en tus alimentos, en tus
              cremas y hasta en tu dormitorio. Estos químicos alteran tu
              metabolismo, disparan el cortisol y causan inflamación crónica.
            </p>
            <p className="text-lg md:text-xl text-dark/80 leading-relaxed mt-6 font-medium" data-id="element-162">
              No importa cuántas dietas o suplementos intentes, si no eliminas
              estas toxinas, tu cuerpo seguirá bloqueado.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}